import { IEProduct } from "api/interfaces/product-api.type";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import JsonExtendedDescriptionTable from "./JsonExtendedDescriptionTable";

interface Props {
  product: IEProduct;
}

const tables = ["productAttributes", "extendedProductAttributes"];
const paragraph = ["marketingDetails"];

const SORT_ORDER = [...paragraph, ...tables];

function JsonExtendedDescription(props: Props) {
  const { product } = props;
  const { data: jsonExtendedDescription, datasource } = product.jsonExtendedDescription || {};

  // only show for ac
  if (!jsonExtendedDescription || datasource !== "ac") {
    return null;
  }

  function getUIType(key: string) {
    if (tables.includes(key)) {
      return "table";
    } if (paragraph.includes(key)) {
      return "paragraph";
    }
    return "";
  }

  function getKeyTitle(key: string) {
    if (key === "marketingDetails") {
      return "Details";
    }
    const result = key.replace(/([A-Z])/g, " $1");
    return result[0].toUpperCase() + result.slice(1);
  }

  function renderSwitch(key: string, uiType: string) {
    switch (uiType) {
    case "table":
      const tableDataObj = jsonExtendedDescription[key];
      return (
        <JsonExtendedDescriptionTable
          tableData={Object.keys(tableDataObj)
            .map((tableKey) => (
              { key: tableKey, value: tableDataObj[tableKey] }
            ))}
        />
      );
    case "paragraph":
      return (
        <PAText style={{
          // whiteSpace: "break-spaces",
          whiteSpace: "pre-line",
        }}
        >
          {jsonExtendedDescription[key].description}

        </PAText>
      );
    default:
      return null;
    }
  }

  return Object.keys(jsonExtendedDescription)
    .sort((a: any, b: any) => SORT_ORDER.indexOf(a) - SORT_ORDER.indexOf(b))
    .map((key) => {
      const uiType = getUIType(key);
      if (!uiType) {
        return null;
      }
      return (
        <div key={key} className="m-t-20">
          <PAText component="h4" bold fontSize={FONT_SIZE[2]}>{getKeyTitle(key)}</PAText>
          {renderSwitch(key, uiType)}
        </div>
      );
    });
}

export default JsonExtendedDescription;
